import { t } from "@lingui/macro";
import React from "react";
import { G, Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const RecurringIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Recurring`} {...props}>
    <G transform="translate(0 2.75)">
      <Path
        fill="currentColor"
        d="M2.75 3c.2 0 .39.08.53.22l2 2a.75.75 0 0 1-.53 1.28H3.5v1.25C3.5 8.44 4.06 9 4.75 9h6a.75.75 0 1 1 0 1.5h-6A2.75 2.75 0 0 1 2 7.75V6.5H.75a.751.751 0 0 1-.53-1.28l2-2A.75.75 0 0 1 2.75 3Zm8-3a2.75 2.75 0 0 1 2.75 2.75V4h1.25a.75.75 0 0 1 .53 1.28l-2 2a.75.75 0 0 1-1.06 0l-2-2A.75.75 0 0 1 10.75 4H12V2.75c0-.69-.56-1.25-1.25-1.25h-6a.75.75 0 0 1 0-1.5h6Z"
      />
    </G>
  </Icon>
);
